<template lang="pug">

div.invalid-field(v-show="parentErrors.has(name, scope)") {{ msg || parentErrors.first(name, scope) }}
		
</template>

<script>
export default {
	name: 'InputErrors',
	props: ['name', 'msg', 'errorBag', 'scope'],
	data () {

		return {
			parentErrors: this.errorBag || this.$parent.errors
		};
	}
};
</script>


// WEBPACK FOOTER //
// InputErrors.vue?621f5859